<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <div
    class="d-flex"
    v-if="loaded"
  >
    <div
      class="form-group m-0 mr-2"
    >
      <ItpFormSelect
        name="mode"
        v-model="mode"
        :options="options"
        valueField="key"
        textField="name"
        required
        :size="size"
        class="w-auto"
        @input="evh_6466705138206980_input($event, {})"
      >
      </ItpFormSelect>
    </div>
    <div
      class="form-group m-0 mr-2"
    >
      <ItpFormDatetime
        name="start"
        type="date"
        v-model="item.start"
        required
        :size="size"
        :style="b_3943151158818434_style"
        @input="evh_3943151158818434_input($event, {})"
      >
      </ItpFormDatetime>
    </div>
    <div
      class="form-group m-0 mr-2"
    >
      <ItpFormDatetime
        name="end"
        type="date"
        v-model="item.end"
        required
        :size="size"
        clearable
        :style="b_4207795475682514_style"
        @input="evh_4207795475682514_input($event, {})"
      >
      </ItpFormDatetime>
    </div>
  </div>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class DateRangeSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
    this.$$cache_mode = new ComponentValueCache(this, "mode", () => this.$$load_mode_cache_key());
  }

  $$load_mode_cache_key() {
    return this.name + '.mode'
  }

  getCurrentWeek(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.startOfWeek(t0, { weekStartsOn: 1 }),
      null
    ];
  }

  getCurrentMonth(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.startOfMonth(t0),
      null
    ];
  }

  getCurrentYear(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.startOfYear(t0),
      null
    ];
  }

  getPreviousWeek(...args: any[]) {
    const prev_monday = this.$fn.dateFns.previousMonday(this.$fn.dateFns.startOfWeek(new Date(), { weekStartsOn: 1 }))
    return [
      prev_monday,
      this.$fn.dateFns.endOfWeek(prev_monday)
    ];
  }

  getPreviousMonth(...args: any[]) {
    const start = this.$fn.dateFns.sub(this.getCurrentMonth()[0], { months: 1 });
    return [
      start,
      this.$fn.dateFns.endOfMonth(start),
    ];
  }

  getPreviousYear(...args: any[]) {
    const start = this.$fn.dateFns.sub(this.getCurrentYear()[0], { years: 1 });
    return [
      start,
      this.$fn.dateFns.endOfYear(start),
    ];
  }

  getPreviousSevenDays(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.sub(t0, { days: 7 }),
      null,
    ];
  }

  getPreviousThirtyDays(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.sub(t0, { days: 30 }),
      null,
    ];
  }

  getPreviousSixtyDays(...args: any[]) {
    const t0 = new Date();
    return [
      this.$fn.dateFns.sub(t0, { days: 60 }),
      null,
    ];
  }

  onModeChanged(...args: any[]) {
    const [key] = args;

    const option = _.find(this.options, { key });
    if (option && option.value) {
      const [start, end] = option.value;

      this.item.start = start ? this.$fn.formatDate(start, 'yyyy-MM-dd') : null;
      this.item.end = end ? this.$fn.formatDate(end, 'yyyy-MM-dd') : null;

      this.$emit('changed', [this.item.start, this.item.end]);
    }
  }

  @Prop({
    required: true,
    type: String,
  })
  name!: string;

  @Watch('name')
  onName(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("name")
  }

  @Prop({
    type: String,
  })
  from!: string;

  @Watch('from')
  onFrom(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("from")
  }

  @Prop({
    type: String,
  })
  to!: string;

  @Watch('to')
  onTo(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("to")
  }

  @Prop({
    type: String,
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return { start: this.from, end: this.to }
  }

  mode!: any;
  options!: any;

  async $$load_options() {
    return [{
      key: "custom",
      name: this.$fn.pgettext("DateRangeSelector", "Custom"),
    }
      ,
    {
      key: "current_week",
      name: this.$fn.pgettext("DateRangeSelector", "Current week"),
      value: this.getCurrentWeek(),
    }
      ,
    {
      key: "current_month",
      name: this.$fn.pgettext("DateRangeSelector", "Current month"),
      value: this.getCurrentMonth(),
    }
      ,
    {
      key: "current_year",
      name: this.$fn.pgettext("DateRangeSelector", "Current year"),
      value: this.getCurrentYear(),
    }
      ,
    {
      key: "previous_week",
      name: this.$fn.pgettext("DateRangeSelector", "Previous week"),
      value: this.getPreviousWeek(),
    }
      ,
    {
      key: "previous_month",
      name: this.$fn.pgettext("DateRangeSelector", "Previous month"),
      value: this.getPreviousMonth(),
    }
      ,
    {
      key: "previous_year",
      name: this.$fn.pgettext("DateRangeSelector", "Previous year"),
      value: this.getPreviousYear(),
    }
      ,
    {
      key: "previous_seven_days",
      name: this.$fn.pgettext("DateRangeSelector", "Previous seven days"),
      value: this.getPreviousSevenDays(),
    }
      ,
    {
      key: "previous_thirty_days",
      name: this.$fn.pgettext("DateRangeSelector", "Previous thirty days"),
      value: this.getPreviousThirtyDays(),
    }
      ,
    {
      key: "previous_60_days",
      name: this.$fn.pgettext("DateRangeSelector", "Previous sixty days"),
      value: this.getPreviousSixtyDays(),
    }
      ,
    ]
  }

  ux!: any;
  b_3943151158818434_style!: any;
  b_4207795475682514_style!: any;
  dataMembers = ['item', 'mode', 'options', 'ux', 'b_3943151158818434_style', 'b_4207795475682514_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        mode: "custom",
        options: null,
        ux: null,
        b_3943151158818434_style: {
          width: "110px",
        }
        ,
        b_4207795475682514_style: {
          width: "110px",
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_script_2422_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6466705138206980_script_2422, alias=undefined
    this.onModeChanged(this.mode)
  }

  async act_6466705138206980_script_2422_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6466705138206980_script_2422, alias=undefined
    return {
      value: () => this.act_6466705138206980_script_2422_getActionArgs_value($event),
    }
  }

  async evh_6466705138206980_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_input.executeFromDOM(this, event, scope);
  }

  async act_3943151158818434_emit_2424_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3943151158818434_emit_2424, alias=undefined
    return {
      event: "changed",
      value: [this.item.start, this.item.end],
    }
  }

  async evh_3943151158818434_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3943151158818434_input.executeFromDOM(this, event, scope);
  }

  async act_4207795475682514_emit_2426_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_4207795475682514_emit_2426, alias=undefined
    return {
      event: "changed",
      value: [this.item.start, this.item.end],
    }
  }

  async evh_4207795475682514_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4207795475682514_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_2420: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_2419: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_6466705138206980_script_2422: actions.ScriptAction;
    evh_6466705138206980_input_2421: actions.EventHandlerImpl;
    evh_6466705138206980_input: actions.EventHandlerGroup;
    act_3943151158818434_emit_2424: actions.EmitAction;
    evh_3943151158818434_input_2423: actions.EventHandlerImpl;
    evh_3943151158818434_input: actions.EventHandlerGroup;
    act_4207795475682514_emit_2426: actions.EmitAction;
    evh_4207795475682514_input_2425: actions.EventHandlerImpl;
    evh_4207795475682514_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_2420 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_2419 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_2420,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_2419],
      }
    );
    const act_6466705138206980_script_2422 = new actions.ScriptAction(
      {
        actionArgs: this.act_6466705138206980_script_2422_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_input_2421 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_script_2422,
        event: "input",
        displayName: "script",
      }
    );
    const evh_6466705138206980_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_input_2421],
      }
    );
    const act_3943151158818434_emit_2424 = new actions.EmitAction(
      {
        actionArgs: this.act_3943151158818434_emit_2424_getActionArgs,
        events: [],
      }
    );
    const evh_3943151158818434_input_2423 = new actions.EventHandlerImpl(
      {
        action: act_3943151158818434_emit_2424,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_3943151158818434_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_3943151158818434_input_2423],
      }
    );
    const act_4207795475682514_emit_2426 = new actions.EmitAction(
      {
        actionArgs: this.act_4207795475682514_emit_2426_getActionArgs,
        events: [],
      }
    );
    const evh_4207795475682514_input_2425 = new actions.EventHandlerImpl(
      {
        action: act_4207795475682514_emit_2426,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_4207795475682514_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_4207795475682514_input_2425],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_2420,
      evh_7315092382398562_reload_2419,
      evh_7315092382398562_reload,
      act_6466705138206980_script_2422,
      evh_6466705138206980_input_2421,
      evh_6466705138206980_input,
      act_3943151158818434_emit_2424,
      evh_3943151158818434_input_2423,
      evh_3943151158818434_input,
      act_4207795475682514_emit_2426,
      evh_4207795475682514_input_2425,
      evh_4207795475682514_input,
    }
  }
}

Vue.component("DateRangeSelector", DateRangeSelector);

</script>